// extracted by mini-css-extract-plugin
export var closeButton = "_gq-2";
export var closeButtonIcon = "_gq-3";
export var lightboxContent = "_gq-1";
export var lightboxOverlay = "_gq-0";